export const STANDALONE_CMS = [
  {
    name: 'CM - Customized heat and gross floor area density maps',
    wiki_url:
      'https://citiwatts.github.io/wiki/heat-cm-customized-heat-and-gross-floor-area-density-maps/',
    repository_url: 'https://github.com/HotMaps/customized_h_fa_dm',
    project: ['citiwatts'],
  },
  {
    name: 'CM - Add Industry Plant',
    wiki_url: 'https://citiwatts.github.io/wiki/industry-cm-add-industry-plant/',
    repository_url: 'https://github.com/HotMaps/add_industry_plant_cm',
    project: ['citiwatts'],
  },
  {
    name: 'CM - District heating supply dispatch',
    wiki_url: 'https://hotmapsdispatch.readthedocs.io/en/latest',
    repository_url: 'https://github.com/tuw-eeg/hotmapsDispatch',
    project: ['citiwatts'],
  },
]
